// REACT
import React, { RefObject, useState, useRef, useContext } from 'react'
import Carousel from 'Components/Carousel/Carousel'
import { Link } from 'react-router-dom'

// ESTILOS
import Styles from './Rooms.module.css'

// IMAGENES

import arrow from 'Assets/General/arrow_down.svg'
import res from 'Assets/Rooms/calendarW.svg'
import hab1_0 from 'Assets/Rooms/habitaciones/hab1-0.jpg'
import hab1_1 from 'Assets/Rooms/habitaciones/hab1-1.jpg'
import hab1_2 from 'Assets/Rooms/habitaciones/hab1-2.jpg'
import hab2_0 from 'Assets/Rooms/habitaciones/hab2-0.jpg'
import hab2_1 from 'Assets/Rooms/habitaciones/hab2-1.jpg'
import hab2_2 from 'Assets/Rooms/habitaciones/hab2-2.jpg'
import hab3_0 from 'Assets/Rooms/habitaciones/hab3-0.jpg'
import hab3_1 from 'Assets/Rooms/habitaciones/hab3-1.jpg'
import hab3_2 from 'Assets/Rooms/habitaciones/hab3-2.jpg'
import hab4_0 from 'Assets/Rooms/habitaciones/hab4-0.jpg'
import hab4_1 from 'Assets/Rooms/habitaciones/hab4-1.jpg'
import hab4_2 from 'Assets/Rooms/habitaciones/hab4-2.jpg'
import hab5_0 from 'Assets/Rooms/habitaciones/hab5-0.jpg'
import hab5_1 from 'Assets/Rooms/habitaciones/hab5-1.jpg'
import hab5_2 from 'Assets/Rooms/habitaciones/hab5-2.jpg'
import hab6_0 from 'Assets/Rooms/habitaciones/hab6-0.jpg'
import hab6_1 from 'Assets/Rooms/habitaciones/hab6-1.jpg'
import hab6_2 from 'Assets/Rooms/habitaciones/hab6-2.jpg'
import hab7_0 from 'Assets/Rooms/habitaciones/hab7-0.jpg'
import hab7_1 from 'Assets/Rooms/habitaciones/hab7-1.jpg'
import hab7_2 from 'Assets/Rooms/habitaciones/hab7-2.jpg'
import hab8_0 from 'Assets/Rooms/habitaciones/hab8-0.jpg'
import hab8_1 from 'Assets/Rooms/habitaciones/hab8-1.jpg'
import hab8_2 from 'Assets/Rooms/habitaciones/hab8-2.jpg'
import hab9_0 from 'Assets/Rooms/habitaciones/hab9-0.jpg'
import hab9_1 from 'Assets/Rooms/habitaciones/hab9-1.jpg'
import hab9_2 from 'Assets/Rooms/habitaciones/hab9-2.jpg'
// import hab10_0 from 'Assets/Rooms/habitaciones/hab10-0.jpg'
// import hab10_1 from 'Assets/Rooms/habitaciones/hab10-1.jpg'
import MainContext from './../../Context/MainContext'
import { ScrollToTop } from 'Hooks/Hooks'

const Rooms: React.FC = () => {
	const [room, setRoom]: [
		(
			| 'quetzaltenango'
			| 'sexto_estado'
			| 'ferrocarril_de_los_altos'
			| 'atractivos_turisticos'
			| 'cuna_de_la_cultura'
			| 'trajes_tipicos'
			| 'instrumentos_musicales'
			| 'cuidad_de_los_altos'
		),
		any
	] = useState('quetzaltenango')

	const { rooms } = useContext(MainContext).lang

	let status: boolean = false
	const menu: RefObject<HTMLDivElement> = React.createRef()

	const roomRef: RefObject<HTMLDivElement> = useRef(null)

	// OBJETO HABITACIONES
	const habitaciones = {
		quetzaltenango: {
			name: rooms.hab_1.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_1.serv_1,
			info2: rooms.hab_1.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab1_0, hab1_1, hab1_2],
		},
		sexto_estado: {
			name: rooms.hab_2.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_2.serv_1,
			info2: rooms.hab_2.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab2_0, hab2_1, hab2_2],
		},
		ferrocarril_de_los_altos: {
			name: rooms.hab_3.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_3.serv_1,
			info2: rooms.hab_3.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab3_0, hab3_1, hab3_2],
		},
		atractivos_turisticos: {
			name: rooms.hab_4.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_4.serv_1,
			info2: rooms.hab_4.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab4_0, hab4_1, hab4_2],
		},
		cuna_de_la_cultura: {
			name: rooms.hab_5.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_5.serv_1,
			info2: rooms.hab_5.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab5_0, hab5_1, hab5_2],
		},
		trajes_tipicos: {
			name: rooms.hab_6.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_6.serv_1,
			info2: rooms.hab_6.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab6_0, hab6_1, hab6_2],
		},
		instrumentos_musicales: {
			name: rooms.hab_7.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_7.serv_1,
			info2: rooms.hab_7.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab7_0, hab7_1, hab7_2],
		},
		recursos_naturales: {
			name: rooms.hab_8.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_8.serv_1,
			info2: rooms.hab_8.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab8_0, hab8_1, hab8_2],
		},
		cuidad_de_los_altos: {
			name: rooms.hab_9.title,
			sub_1: rooms.serv_1,
			sub_2: rooms.serv_2,
			sub_3: rooms.serv_3,
			info: rooms.hab_9.serv_1,
			info2: rooms.hab_9.serv_2,
			info3: rooms.serv_4,
			info4: rooms.serv_5,
			imgs: [hab9_0, hab9_1, hab9_2],
		},
	}

	const computeInfo = (e: number) => {
		let txt: string = ''
		switch (e) {
			case 1:
				habitaciones[room].info.forEach((msj) => {
					txt += `${msj}<br>`
				})
				return <div dangerouslySetInnerHTML={{ __html: txt }} />
			case 2:
				habitaciones[room].info2.forEach((msj) => {
					txt += `${msj}<br>`
				})
				return <div dangerouslySetInnerHTML={{ __html: txt }} />
			case 3:
				habitaciones[room].info3.forEach((msj) => {
					txt += `${msj}<br>`
				})
				return <div dangerouslySetInnerHTML={{ __html: txt }} />
			case 4:
				habitaciones[room].info4.forEach((msj) => {
					txt += `${msj}<br>`
				})
				return <div dangerouslySetInnerHTML={{ __html: txt }} />
			default:
				break
		}
		// return <div dangerouslySetInnerHTML={{ __html: habitaciones[room].info }} />
	}

	const showMenu = () => {
		if (status === false) {
			menu.current!.style.display = 'flex'
			status = true
			return
		} else {
			menu.current!.style.display = 'none'
			status = false
			return
		}
	}

	ScrollToTop('')

	return (
		<>
			<div className={Styles.contBanner} />
			<section className={Styles.container} ref={roomRef}>
				<div className={Styles.contHab}>
					<div className={Styles.habitacion}>
						<div className={Styles.selectHabitacion}>
							<h1>{rooms.text_1}</h1>
							<img src={arrow} width='50px' alt='arrow down' onClick={showMenu} />
							<div className={Styles.selectOptionHab} ref={menu}>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('quetzaltenango')
										showMenu()
									}}>
									<p>01.</p>
									{habitaciones['quetzaltenango'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('sexto_estado')
										showMenu()
									}}>
									<p>02.</p>
									{habitaciones['sexto_estado'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('ferrocarril_de_los_altos')
										showMenu()
									}}>
									<p>03.</p>
									{habitaciones['ferrocarril_de_los_altos'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('atractivos_turisticos')
										showMenu()
									}}>
									<p>04.</p>
									{habitaciones['atractivos_turisticos'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('cuna_de_la_cultura')
										showMenu()
									}}>
									<p>05.</p>
									{habitaciones['cuna_de_la_cultura'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('trajes_tipicos')
										showMenu()
									}}>
									<p>06.</p>
									{habitaciones['trajes_tipicos'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('instrumentos_musicales')
										showMenu()
									}}>
									<p>07.</p>
									{habitaciones['instrumentos_musicales'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('recursos_naturales')
										showMenu()
									}}>
									<p>08.</p>
									{habitaciones['recursos_naturales'].name}
								</div>
								<div
									className={Styles.selectOption}
									onClick={() => {
										setRoom('cuidad_de_los_altos')
										showMenu()
									}}>
									<p>09.</p>
									{habitaciones['cuidad_de_los_altos'].name}
								</div>
							</div>
						</div>
						<p>{habitaciones[room].name}</p>
						<div className={Styles.carrosuelMovil}>
							<Carousel
								imgs={habitaciones[room].imgs}
								class1={{
									minWidth: '300px',
									height: '300px',
									position: 'relative',
									borderRadius: '10px',
								}}
								update
								class2={{ width: '300px', height: '300px', margin: '0px', borderRadius: '20px' }}
							/>
						</div>
						<div className={Styles.contInfo}>
							<h3>{habitaciones[room].sub_1}</h3>
							{computeInfo(1)}
							<br />
							<h3>{habitaciones[room].sub_2}</h3>
							{computeInfo(2)}
							<br />
							<h3>{habitaciones[room].sub_3}</h3>
							{computeInfo(3)}
							<br />
							{computeInfo(4)}
						</div>
						<Link to='/reservaciones' className={Styles.linkAlto}>
							<button className={Styles.button}>
								<img src={res} alt='reservation' />
								{rooms.text_2}
							</button>
						</Link>
					</div>
					<div className={Styles.imgsHab}>
						<div className={Styles.carrosuel}>
							<Carousel
								imgs={habitaciones[room].imgs}
								class1={{
									width: '350px',
									minWidth: '200px',
									height: '350px',
									minHeight: '200px',
									position: 'relative',
									borderRadius: '10px',
								}}
								update
								class2={{ width: '350px', height: '350px', borderRadius: '20px' }}
							/>
						</div>
						<Link to='/reservaciones' className={Styles.linkBajo}>
							<button className={Styles.button}>
								<img src={res} alt='reservation' />
								{rooms.text_2}
							</button>
						</Link>
					</div>
				</div>
			</section>
		</>
	)
}

export default Rooms
